export const FETCH_SUBJECTS='FETCH_SUBJECTS';
export const FETCH_SUBJECTS_SUCCESS='FETCH_SUBJECTS_SUCCESS';
export const FETCH_SUBJECTS_FAILURE='FETCH_SUBJECTS_FAILURE';